import { jsx as _jsx } from "react/jsx-runtime";
const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    borderRadius: 1000,
    fontFamily: "var(--font-display)",
    fontWeight: 700,
    letterSpacing: "0.02em",
    lineHeight: 1,
    whiteSpace: "nowrap",
    transition: "background-color 120ms ease-out, color 120ms ease-out, border-color 120ms ease-out, opacity 120ms ease-out",
    cursor: "pointer",
};
const variantStyle = {
    filled: {
        backgroundColor: "var(--color-deep-ink)",
        color: "var(--color-pure-white)",
        border: "1px solid var(--color-deep-ink)",
    },
    ghost: {
        backgroundColor: "transparent",
        color: "var(--color-pure-white)",
        border: "1px solid var(--color-pure-white)",
    },
    outline: {
        backgroundColor: "transparent",
        color: "var(--color-deep-ink)",
        border: "1px solid var(--color-deep-ink)",
    },
};
const sizeStyle = {
    sm: { padding: "10px 16px", fontSize: 14 },
    md: { padding: "15px 22px 16px 22px", fontSize: 17 },
};
export function PillButton({ variant = "filled", size = "md", fullWidth = false, disabled = false, style, children, ...rest }) {
    const merged = {
        ...baseStyle,
        ...variantStyle[variant],
        ...sizeStyle[size],
        width: fullWidth ? "100%" : undefined,
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        ...style,
    };
    return (_jsx("button", { ...rest, disabled: disabled, style: merged, children: children }));
}
